

import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PsegLoadHistService } from './pseg-load-hist.service';
import { LoadHist } from '../Models/LoadsData';

@Injectable({
  providedIn: 'root'
})
export class PsegMonthlyLoadResolverService implements Resolve<Array<LoadHist>> {
  psegMonthlyHistData: Observable<Array<LoadHist>>;
  constructor(private PsegLoadSvc: PsegLoadHistService) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Array<LoadHist>> | Promise<Array<LoadHist>> | Array<LoadHist> {

    this.psegMonthlyHistData = this.PsegLoadSvc.getPSEGHistData("monthlyDist")
    return this.psegMonthlyHistData;
  }
}
